
function initAnimation() {
  gsap.fromTo('.bag-illustration__img--2', {
    opacity: 0,
  }, {
    opacity: 1,
    scrollTrigger: {
      trigger: '.section--bag-illustration-2',
      start: 'top bottom',
      end: '+=300',
      scrub: 1,
    }
  });

  gsap.fromTo('.bag-illustration__img--2', {
    y: -300,
  }, {
    y: -50,
    scrollTrigger: {
      trigger: '.section--bag-illustration-2',
      start: 'top bottom',
      end: isMobile ? '+=500' : '+=1000',
      scrub: 1,
    }
  });
}

document.addEventListener('DOMContentLoaded', initAnimation);